import enLocale from "@src/packages/i18n/locales/en.json";
import frLocale from "@src/packages/i18n/locales/fr.json";
import type { TranslationFunction } from "@src/packages/i18n";

type LabelMap = Record<string, string>;

type LocaleJson = {
  add_appointment?: {
    type?: Record<string, string>;
    activity?: { item?: Record<string, string> };
    exam_section?: { item?: Record<string, string> };
    procedure_section?: { item?: Record<string, string> };
  };
};

function collectSection(
  json: LocaleJson,
  section: "exam_section" | "procedure_section",
): LabelMap {
  const items = json.add_appointment?.[section]?.item ?? {};
  const map: LabelMap = {};
  for (const [key, value] of Object.entries(items)) {
    map[value] = `add_appointment.${section}.item.${key}`;
  }
  return map;
}

function collectActivities(json: LocaleJson): LabelMap {
  const items = json.add_appointment?.activity?.item ?? {};
  const map: LabelMap = {};
  for (const [key, value] of Object.entries(items)) {
    map[value] = `add_appointment.activity.item.${key}`;
  }
  return map;
}

function collectTypes(json: LocaleJson): LabelMap {
  const types = json.add_appointment?.type ?? {};
  const map: LabelMap = {};
  for (const [key, value] of Object.entries(types)) {
    map[value] = `add_appointment.type.${key}`;
  }
  return map;
}

const REVERSE_MAP: LabelMap = {
  ...collectSection(enLocale, "exam_section"),
  ...collectSection(enLocale, "procedure_section"),
  ...collectSection(frLocale, "exam_section"),
  ...collectSection(frLocale, "procedure_section"),
  ...collectTypes(enLocale),
  ...collectTypes(frLocale),
  ...collectActivities(enLocale),
  ...collectActivities(frLocale),
};

/**
 * Appointment titles are persisted as the display string from the locale active
 * at creation time. Re-localize at render time by reverse-looking the stored
 * title against known EN+FR labels and resolving through t() when matched.
 */
export function localizeAppointmentTitle(
  title: string | null | undefined,
  t: TranslationFunction,
): string {
  if (!title) return "";
  const labelKey = REVERSE_MAP[title.trim()];
  return labelKey ? t(labelKey) : title;
}
